import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { binsValues } from '../constants';

const CohortBinsDropdownItems = ({ value, onChange }) => (
  binsValues.map((bin) => (
    <Dropdown.Item
      key={`cohort_bins_dropdown_${bin}`}
      text={bin}
      value={bin}
      active={bin === value}
      onClick={() => onChange(bin)}
    />
  ))
);

export default CohortBinsDropdownItems;
